<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content" v-menu-permission="'list'">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                           ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesQualityToolBorrowRecordResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName" :inlineActionsDisabled="prop_inline!=='1'"
                        :query-api="$_emWorkflowListMixin_queryApi"
                        :ref="modelName+'Table'" exportDisabled
                        withCustomRowActions>
                <template slot="customRowActions" slot-scope="customRowScope">
                  <b-button-group>
                    <em-button type="task"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="$_emWorkflowListMixin_handleApprove(customRowScope.row)">
                    </em-button>
                  </b-button-group>
                </template>
                <template #left-header>
                    <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="queryAllBorrowRecord()"
                    >查看所有借还记录</b-button>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
// Author Shi Wenlong
// Date 2021-05-31 17:05:47
import emWorkflowListMixin from "@/mixin/em/workflow/list";
import emCommonListMixin from "@/mixin/em/common/list";
import emApiMixin from "@/mixin/em/common/api";
import { mapActions } from "vuex";

export default {
  name: "sithMesQualityToolBorrowRecordWorkflowListView",
  mixins: [emWorkflowListMixin,emApiMixin,emCommonListMixin],
  data(){
      return {
          autoSearchFlag: false,
      }
  },
  props: {
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    toolCode(){
        return this.$route.params.toolCode;
    }
  },
  methods:{
    ...mapActions("base", ["MMFLoadRows"]),
    queryAllBorrowRecord() {
        this.$refs['sithMesQualityToolBorrowRecordTable'].queryApi = 'findByFilter';
        this.MMFLoadRows('sithMesQualityToolBorrowRecord');
        this.$refs['sithMesQualityToolBorrowRecordTable'].queryApi = this.$_emWorkflowListMixin_queryApi;
    }
  },
  created() {
     if(this.toolCode) {
        this.$_emCommonListMixin_needToRefresh = false;
     }
  },
  mounted(){
    const that = this;
    //从总账索引过来的
    if(this.toolCode) {
        const url = that.$store.state.sithMesQualityToolBorrowRecord.baseModuleUrl + '/sithMesQualityToolBorrowRecord/findByToolCodeAndStatus/'+this.toolCode;
        that.$_emApiMixin_post(url, {}).then(response => {
            console.log(response.data);
            that.$refs['sithMesQualityToolBorrowRecordTable'].$_emCustomVuexMixin_voStore = response.data;
            that.$_emCommonListMixin_needToRefresh = true;
        });
    } else {
        this.$refs["emListFilter"].doQuery();
    }
  }
};
</script>